<div class="form-horizontal">
    <div class="card-content">
        <div style="overflow-x: scroll; overflow-y: hidden; height:784px;">
            <canvas id="kioskCanvas" width="1241" height="698" style="border:1px solid #aaa"></canvas>
        </div>
    </div>
</div>